var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useProperties } from "./hook/properties.hook";
import { PropertiesView } from "./view/properties.view";
export var PropertiesAdmin = function () {
    var p = useProperties();
    return _jsx(PropertiesView, __assign({}, p));
};
export default PropertiesAdmin;
